import { render, staticRenderFns } from "./PrintTechniqueHeader.vue?vue&type=template&id=893df954&scoped=true"
import script from "./PrintTechniqueHeader.vue?vue&type=script&lang=ts"
export * from "./PrintTechniqueHeader.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PrintTechniqueHeader.vue?vue&type=style&index=0&id=893df954&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "893df954",
  null
  ,true
)

export default component.exports